import { combineReducers } from 'redux';
import alert from './alert';
import auth from './auth';
import vendingMachine from './vendingMachine'
import product from './product'
import order from './order';
import user from './user';
import profile from './profile';
import region from './region';
import inventory from './inventory';
import canTransaction from './canTransaction';
import downloads from './downloads';
import transactionLedger from './transactionLedger';
import test from './test';
import sales from './sales';
import accountDeletion from './accountDeletion';
import productPackage from './productPackage';
import membership from './membership';
import notes from './notes';
import depositLedger from './depositLedger';
import accessory from './accessory';
import accessoryPurchase from './accessoryPurchase';
import unserviceableAreaRequest from './unserviceableAreaRequest';
import getStarted from './getStarted';
import referralContent from './referralContent';
import delivery from './delivery';
import deliveryCanTransaction from './deliveryCanTransaction';
import canReturn from './canReturn';
import agent from './agent';
import serviceableArea from './serviceableArea';
import superServiceableArea from './superServiceableArea';
import sector from './sector';
import inventoryNode from './inventoryNode';
import agentAssignment from './agentAssignment';
import notification from './notification';
import faq from './faq';
import waterQuality from './waterQuality';
import referralLedger from './referralLedger';
import deliveryProfile from './deliveryProfile';
import dashboard from './dashboard';
import refund from './refund';
import paymentLink from './paymentLink';
import whatsappAnalytics from './whatsappAnalytics';

export default combineReducers({
    alert,
    auth,
    vendingMachine,
    product,
    order,
    user,
    profile,
    region,
    inventory,
    canTransaction,
    downloads,
    transactionLedger,
    test,
    sales,
    accountDeletion,
    productPackage,
    membership,
    notes,
    depositLedger,
    accessory,
    accessoryPurchase,
    unserviceableAreaRequest,
    getStarted,
    referralContent,
    delivery,
    deliveryCanTransaction,
    canReturn,
    agent,
    serviceableArea,
    superServiceableArea,
    sector,
    inventoryNode,
    agentAssignment,
    notification,
    faq,
    waterQuality,
    referralLedger,
    deliveryProfile,
    dashboard,
    refund,
    paymentLink,
    whatsappAnalytics
});